const OfflinePage = () => {
  return (
    <div className="off-main bg-[#e9ecf1] h-[100vh] w-[100vw] flex-center justify-center">
      <h1 className="text-[15px] text-white w-[255px] h-10 bg-[#fc8019] font-bold py-[11px] px-5 rounded-md text-center">
        You Are Offline...!
      </h1>
    </div>
  );
};

export default OfflinePage;
